module.exports = __webpack_public_path__ + "img/PAYCO_KR.3ceed3ab.png";